<template>
  <div class="source-dialog-expanded-header">
    <div class="item">
      <md-radio
        md-value="elibrary"
        v-model="type"
        :disabled="disabled"
      >Ссылка на статью на E-Library.ru</md-radio>
      <md-input-container
        :class="{'md-input-invalid': $v.elibraryLink && $v.elibraryLink.$error}"
        @click.native="ensureType('elibrary')"
      >
        <label>Ссылка</label>
        <md-input
          ref="elibraryInput"
          v-model="elibraryLink"
          :disabled="disabled || type !== 'elibrary'"
          @keyup.enter="onLoad"
        ></md-input>
        <span
          v-if="$v.elibraryLink && $v.elibraryLink.$error"
          class="md-error"
        >
          Укажите ссылку на статью E-library вида https://elibrary.ru/item.asp?id=123456789
        </span>
      </md-input-container>
    </div>
    <div class="item">
      <md-radio
        md-value="resource"
        v-model="type"
        :disabled="disabled"
      >Ссылка на электронный ресурс</md-radio>
      <md-input-container
        :class="{'md-input-invalid': $v.resourceLink && $v.resourceLink.$error}"
        @click.native="ensureType('resource')"
      >
        <label>Ссылка</label>
        <md-input
          ref="resourceInput"
          v-model="resourceLink"
          :disabled="disabled || type !== 'resource'"
        ></md-input>
        <span
          v-if="$v.resourceLink && $v.resourceLink.$error"
          class="md-error"
        >
          Укажите URL электронного ресурса
        </span>
      </md-input-container>
    </div>
    <div class="buttons">
      <md-button
        class="md-raised"
        :disabled="disabled"
        @click="onToggleCustom"
      >Дополнительно...</md-button>
      <md-button
        class="md-raised md-primary"
        :disabled="disabled"
        @click="onLoad"
      >Загрузить</md-button>
    </div>
  </div>
</template>

<script>
import { elibraryRegExp } from '@/shared/resoucesRegexps.js'
import { required, url } from 'vuelidate/lib/validators'

export default {
  name: 'SourceDialogExpandedHeader',

  props: {
    value: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      type: 'elibrary',
      elibraryLink: '',
      resourceLink: ''
    }
  },

  validations () {
    if (this.type === 'elibrary') {
      return {
        elibraryLink: {
          required,
          pattern: (value) => {
            return !!elibraryRegExp.test(value)
          }
        }
      }
    } else if (this.type === 'resource') {
      return {
        resourceLink: {
          required,
          url
        }
      }
    }
  },

  mounted () {
    window.addEventListener('keydown', this.onKey)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKey)
  },

  methods: {
    prepare () {
      if (this.type === 'resource' && this.resourceLink.indexOf('://') == -1) {
        this.resourceLink = `http://${this.resourceLink}`
      }
    },
    ensureType (type) {
      if (this.type !== type) {
        this.type = type
        if (type === 'elibrary') {
          this.$nextTick(() => {
            this.$refs.elibraryInput.$el.focus()
          })
        } else if (type === 'resource') {
          this.$nextTick(() => {
            this.$refs.resourceInput.$el.focus()
          })
        }
      }
    },
    onLoad () {
      this.prepare()
      this.$v.$touch()
      if (!this.$v.$error) {
        if (this.type === 'elibrary') {
          const id = this.elibraryLink.replace(elibraryRegExp, '$2')
          this.$emit('load-article', id)
        } else if (this.type === 'resource') {
          this.$emit('load-digital-resource', this.resourceLink)
        }
      }
    },
    onKey (event) {
      if (event.keyCode == 13) {
        this.onLoad()
      }
    },
    onToggleCustom () {
      this.$emit('toggle-custom')
    }
  }
}
</script>

<style lang="sass">
.source-dialog-expanded-header
  .item
    display: flex
    align-items: center

    .md-radio-label
      min-width: 250px
</style>


// WEBPACK FOOTER //
// SourceDialogExpandedHeader.vue?47266631